export const customTextColorClass = "text-[#6C58E8]";
export type FeatureType = "copilot" | "activity_scores";
export const COPILOT_FEATURE: FeatureType = "copilot";
export const ACTIVITY_SCORES_FEATURE: FeatureType = "activity_scores";
